export const NAVIGATION = {
  name: 'Patienten',
  icon: 'fa-address-book',
  path: '/module/patient/',
  children: [
    {
      name: 'Liste',
      path: '/module/patient/grid',
      icon: 'fa-table'
    },
    {
      name: 'Importieren',
      path: '/module/patient/import',
      icon: 'fa-upload'
    },
    {
      name: 'Neu anlegen',
      path: '/module/patient/crud/new',
      icon: 'fa-star'
    },
    {
      name: 'Anonym',
      path: '/module/patient/crud/new/anonymous',
      icon: 'fa-user-secret',
      sub: true
    },
    {
      name: 'Pseudonym',
      path: '/module/patient/crud/new/pseudonymous',
      icon: 'fa-user-o',
      sub: true
    },
    // loaded patient: only shown while open, labelled with the patient name by the crud component
    {
      name: 'Bearbeiten',
      path: '/module/patient/crud/:id',
      icon: 'fa-pencil',
      context: true
    },
    {
      name: 'Bearbeiten',
      path: '/module/patient/assign/:id',
      icon: 'fa-pencil',
      context: true
    },
  ]
};
